

































































import {Component, Prop, Vue} from 'vue-property-decorator';

import ProjectBreadcrumb from '@/views/components/projects/ProjectBreadcrumb.vue';
import {IProjectMetadata} from '@/interfaces/report';
import {UnitSystem} from '@/interfaces/units';

import {designStore, projectStore} from '@/store/store';
import ErrorDisplay from '@/views/components/projects/ErrorDisplay.vue';


@Component({
  components: {
    ErrorDisplay,
    ProjectBreadcrumb,
    // ScenarioInfo: NewAsphaltScenarioInfo,
    // DesignParameters: NewAsphaltDesignParameters,
  },
  validations: () => ({}),
})
export default class DesignScenario extends Vue {
  @Prop() pages!: { link: string, text: string }[];

  @Prop() pxDesignId!: number;

  @Prop() designScenarioType!: string;

  projectMetadata: IProjectMetadata | null = null;

  get httpErrors() {
    const e: any[] = [];
    return e.concat(designStore.httpErrors).concat(projectStore.httpErrors);
  }

  clearErrors() {
    designStore.clearErrors();
    projectStore.clearErrors();
  }

  get units() {
    console.log('Units changed to', designStore.displayUnits);
    return designStore.displayUnits;
  }

  get currentPageNum() {
    const cp = this.$route.path.substring(this.$route.path.lastIndexOf('/') + 1);
    return Number(cp);
  }

  get prevPage(): string {
    if (this.currentPageNum > 1) {
      return (this.currentPageNum - 1).toString();
    }
    return this.currentPageNum.toString();
  }

  get nextPage(): string {
    return (this.currentPageNum + 1).toString();
  }

  get scenarioTypeText() {
    switch (this.designScenarioType) {
      case 'asphalt':
        return "AASHTO '93/'98: Flexible Pavement Design";
      case 'concrete':
        return "AASHTO '93/'98: Rigid Pavement Design";
      case 'porous':
        return "AASHTO '93/'98: Flexible Porous Pavement Design";
      case 'acOverlay':
        return "AASHTO '93/'98: Flexible Overlay Pavement Design";
      case 'lcca':
        return 'Life Cycle Cost Analysis';
      default:
        return null;
    }
  }

  get scenarioHeaderCssClass() {
    switch (this.designScenarioType) {
      case 'asphalt':
        return {'scenario-design-header': true};
      case 'concrete':
        return {'scenario-design-header': true};
      case 'porous':
        return {'scenario-design-header': true};
      case 'acOverlay':
        return {'scenario-design-header': true};
        // case 'lcca':
        //   return {"scenario-lcca-header": true};
      default:
        return null;
    }
  }


  set currentPageNum(v) {
    console.log('Set to', v);
  }

  // linkGen(pageNum: number){
  //   return {
  //     path: `${pageNum}`
  //   }
  // }

  mounted() {
    this.clearErrors();
    console.log('loading data in designscenariocontainer for', this.designScenarioType, this.pxDesignId);
    switch (this.designScenarioType) {
      case 'asphalt':
        console.log('Initializing asphalt');
        designStore.loadCurrentAsphaltScenario(this.pxDesignId).then((scenario) => {
          designStore.setDisplayUnits(scenario.displayUnits);
          projectStore.getProjectMetadata(scenario.project).then((meta) => this.projectMetadata = meta);
        });
        break;
      case 'concrete':
        console.log('Initializing concrete');
        designStore.loadCurrentConcreteScenario(this.pxDesignId).then((scenario) => {
          designStore.setDisplayUnits(scenario.displayUnits);
          projectStore.getProjectMetadata(scenario.project).then((meta) => this.projectMetadata = meta);
        });
        break;
      case 'porous':
        console.log('Initializing porous');
        designStore.loadCurrentPorousScenario(this.pxDesignId).then((scenario) => {
          designStore.setDisplayUnits(scenario.displayUnits);
          console.log('porous scenario loaded');
          projectStore.getProjectMetadata(scenario.project).then((meta) => this.projectMetadata = meta);
        });
        break;
      case 'acOverlay':
        console.log('Initializing AC overlay');
        designStore.loadCurrentAcOverlayScenario(this.pxDesignId).then((scenario) => {
          console.log('ac overlay scenario loaded', scenario.designScenarioType);
          designStore.setDisplayUnits(scenario.displayUnits);
          projectStore.getProjectMetadata(scenario.project).then((meta) => this.projectMetadata = meta);
        });
        break;
      default:
        return null;
    }
  }

  // get projectMetadata() {
  //   if (this.scenario){
  //     return this.scenario.project
  //   }
  //   return null
  // }

  get scenario() {
    return designStore.currentScenarioImperial;
  }

  get currentUnitSystem() {
    if (this.scenario) {
      return designStore.displayUnits;
    }
    return null;
  }

  get currentUnitSystemIsImperial() {
    return designStore.displayUnits === UnitSystem.Imperial;
  }

  public displayImperial: boolean = true;

  saveUnitSelection() {
    console.log('Saving Unit Selection IN DesignScenarioContainer');
    console.log('is imperial', this.currentUnitSystemIsImperial);
    if (this.currentUnitSystemIsImperial) {
      designStore.setDisplayUnits(UnitSystem.Metric);
    } else {
      designStore.setDisplayUnits(UnitSystem.Imperial);
    }
  }
}
